<template>
    <div id="app" :class="{home: isHome, spacing: !hasTenant, sidebaropen : openSidebar, 'inbox': isInbox, 'other_service': specificService, 'animate_credit' : animateCredit, 'show__credits' : showCredits}" class="animated fadeIn">
        <svg-pageloader v-if="pageLoading" />
        <svg-pageloader :createTeam="true" v-if="deployingEnvironment" />
        <svg-pageloader :switchProject="true" v-if="switchingTeam && !deployingEnvironment" />
        <section class="app-body" v-if="!pageLoading && !deployingEnvironment && !switchingTeam">
            <f-sidebar :navItems="nav" />
            <main class="main" :class="{'main--home': isHome || $route.meta.sidebar === 'emk' && specificService || (specificService  && $route.name !== 'inbox' && $route.meta.sidebar !== 'team' && $route.meta.sidebar && !$route.meta.sidebar.includes('gardenerPages'))}">
                <div class="main-inner">
                    <f-top-header v-if="!$route.path.includes('error')" />
                    <b-container fluid>
                        <f-billing-modal/>
                        <f-team-modal/>
                        <f-notification-modal/>
                        <f-os-modal v-if="hasTenant"/>
                        <f-emk-modal />
                        <b-alert v-if="adBlockEnabled" variant="danger" show>Please disable your adblock to prevent any errors</b-alert>
                        <div v-if="!specificService">
                            <b-alert v-if="!hasTenant & hasUser" variant="warning" show>Please <a href="#" @click.prevent="findRegistrationStep()">complete your profile</a></b-alert>
                        </div>
                        <router-view></router-view>
                    </b-container>
                </div>
            </main>
            <f-mobile-menu />
        </section>
    </div>
</template>
<script>
import { AUTH_URL, REGION_URLS } from '@/assets/js/config';
import fSidebar from '@/components/menu/f-sidebar';
import fMobileMenu from '@/components/menu/f-mobile-menu';
import fTopHeader from '@/components/menu/f-top-header';
import fFooter from '@/components/f-footer';
const svgPageloader = () => import('@/components/svg/svg-pageloader');
const fBillingModal = () => import('@/components/modals/f-billing-modal');
const fTeamModal = () => import('@/components/modals/f-team-modal');
const fOsModal = () => import('@/components/modals/f-os-modal');
const fEmkModal = () => import('@/components/modals/f-kubernetes-modal');
const fNotificationModal = () => import('@/components/modals/f-notification-modal');

export default {
    data() {
        return {
            alertIsVisible: true,
            nav: [],
            AuthUrl: AUTH_URL,
            regionUrls: REGION_URLS,
        }
    },

    computed: {
        openSidebar: {
            get() {
                return this.$store.state.misc.showSidebar;
            },
        },

        adBlockEnabled() {
            return this.$store.state.misc.adBlockEnabled;
        },
    },

    methods: {
        hideAlert() {
            localStorage.setItem('alert_hidden', true);
            this.alertIsVisible = false;
        },

        checkAlertStatus() {
            let alertStatus = localStorage.getItem('alert_hidden');
            if (alertStatus) {
                this.hideAlert();
            }
        },

        getCookie(name) {
          var cookieArr = document.cookie.split(";");
          let result = false;
          for(var i = 0; i < cookieArr.length; i++) {
              var cookiePair = cookieArr[i].split("=");
              if(name == cookiePair[0].trim()) {
                  result = decodeURIComponent(cookiePair[1]);
                  if (result === 'true') {
                      this.$store.commit('misc/SHOW_SIDEBAR', true);
                  } else {
                      this.$store.commit('misc/SHOW_SIDEBAR', false);
                  }
              }
          }
        },

        checkAdBlocker() {
          var testAd = document.createElement('div');
          testAd.innerHTML = '&nbsp;';
          testAd.className = 'adsbox';
          document.body.appendChild(testAd);
          setTimeout(() => {
            if (testAd.offsetHeight === 0) {
              this.$store.commit('misc/SET_ADBLOCK_STATUS', true);
            }
            testAd.remove();
          }, 100);
        },

        retrieveNewToken() {
            localStorage.removeItem('id_token');
            location.reload();
        },
    },

    created() {
        this.$store.commit('misc/PAGE_LOADING', true);
        if (this.isLoggedIn) {
            setTimeout(() => {
                this.checkApiStatus();
                // Maintenance redirect
                // window.location = 'https://status.fuga.cloud';
                if (this.$router.currentRoute.name !== 'logout') {
                    if (!this.hasUser) {
                        this.setUserData();
                    }
                } else {
                    if (window.location.pathname !== "/post-login") {
                        this.$store.commit('misc/PAGE_LOADING', false);
                    }
                }
            }, 1000);
        } else {
              if (window.location.pathname !== "/post-login") {
                  this.$store.commit('misc/PAGE_LOADING', false);
              }
        }
        this.getCookie('sidebar');

        document.addEventListener('keyup', function (evt) {
            // escape key
            if (evt.keyCode === 27) {
              var elts = document.getElementsByClassName("confirm");
                  for(var e = 0; e < elts.length; e++) {
                     var elt = elts[e];
                     elt.classList.remove("confirm");
                  }
            }
        });
    },

    mounted() {
        this.checkAlertStatus();
        let statusPageScript = document.createElement('script')
        statusPageScript.setAttribute('src', 'https://9dq3gm48b8br.statuspage.io/embed/script.js')
        document.head.appendChild(statusPageScript);

        window.hsConversationsSettings = {
          loadImmediately: false,
        };
        this.checkAdBlocker();
    },

    components: {
        fSidebar,
        fTopHeader,
        fFooter,
        svgPageloader,
        fBillingModal,
        fTeamModal,
        fOsModal,
        fEmkModal,
        fMobileMenu,
        fNotificationModal,
    }
}
</script>

<style scoped>
.main {margin-right: 0;}
.main {
    margin-left: 60px;
}
.sidebaropen .main {
    margin-left: 0px;
}
</style>
<style>
.compute-create, .kubernetes-create, .load-balancer-create {
    margin-bottom: 350px;
}

.other_service .launch-instance-footer {
  left: 55px;
}
.other_service.sidebaropen .launch-instance-footer {
  left: 200px;
}
.mainsidebar {z-index: 8;}

lottie-player::after {
    width: 100px;
    height: 10px;
    background: #CED8DC;
    content: '';
    display: block;
    border-radius: 50%;
    margin: -20px auto;
}
.flex {
    display: flex;
}
.svg-image {
    max-width: 200px;
    margin: 0 auto 10px auto;
    display: block;
}
.icon-service {
    min-width: 45px;
}
.list__menu {
    display: flex;
}
.btn-cta, .btn-cta--reverse, .btn-default, .btn-default--reverse, .btn-primary, .btn-primary--reverse, .btn-secondary, .btn-secondary--reverse {
    line-height: 1.4;
}
.list__menu .dropdown-btn {
    padding: 0;
}
.list__menu .dropdown-btn .btn {
    margin: 0 !important;
    height: 30px;
    width: 30px;
}
</style>
